export default "__VITE_ASSET__c077752f__"